var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0C13.0048 0 7.3335 5.67133 7.3335 12.6667C7.3335 19.662 13.0048 25.3333 20.0002 25.3333C26.9955 25.3333 32.6668 19.662 32.6668 12.6667C32.6668 5.67133 26.9955 0 20.0002 0ZM20.0002 16.5613L16.5928 19.1087C15.6082 19.792 14.3308 18.8007 14.7482 17.678L15.8948 13.8867L12.4588 11.354C11.5875 10.714 12.0408 9.33333 13.1222 9.33333H17.1268L18.7522 5.544C18.9388 5.03333 19.4248 4.66667 20.0002 4.66667C20.5755 4.66667 21.0615 5.03333 21.2482 5.544L22.8742 9.33333H26.8788C27.9602 9.33333 28.4135 10.714 27.5422 11.3547L24.1062 13.8873L25.2535 17.6787C25.6702 18.8013 24.3928 19.7927 23.4088 19.1093L20.0002 16.5613Z",
    fill: "#0496FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0122 27.9998C20.0082 27.9998 20.0042 27.9998 20.0002 27.9998C16.7835 27.9998 13.7995 27.0078 11.3335 25.3151V39.3331L20.0002 34.6665L28.6668 39.3331V25.3145C26.2048 27.0051 23.2242 27.9971 20.0122 27.9998Z",
    fill: "#0496FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/Medal.c08199d70dd4e0c8281b2db31a7da7c2.svg";
export { ForwardRef as ReactComponent };